import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ongoingOrders } from "../../../redux/orders/actions/orders.actions";
import { cylinderOrders } from "../../../redux/orders/actions/orders.actions";
import Pagination from "../../paginationCopy/Pagination";
import Hospital from "./Hospital";
import { LinearLoader } from "../../Loader/LinearLoader";
import CircularLoader from "../../Loader/CircularLoader";
import { useNavigate } from "react-router-dom";
import Search from "../../search";

const CylinderHospital = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filterData, setFilterData] = useState([]);

  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("");

  // const { ongoing } = useSelector((state) => state.orderReducer);
  const { cylinder } = useSelector((state) => state.orderReducer);
  // console.log("cylinder", cylinder);

  // console.log("completed:::", completed);
  const dispatch = useDispatch();

  // const fetchOngoingOrders = () => {
  //   dispatch(ongoingOrders());
  // };

  const fetchCylinderOrders = () => {
    dispatch(cylinderOrders());
  };

  // useEffect(() => {
  //   setLoading(true);
  //   fetchOngoingOrders();
  //   const myInterval = setInterval(fetchOngoingOrders, 30000);
  //   setLoading(false);

  //   return () => {
  //     clearInterval(myInterval);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    setLoading(true);
    fetchCylinderOrders();
    const myInterval = setInterval(fetchCylinderOrders, 30000);
    setLoading(false);

    return () => {
      clearInterval(myInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Search handler
  // useEffect(() => {
  //   setData(
  //     ongoing?.filter((id) => {
  //       return Object.values(id).some((name) =>
  //         String(name).toLowerCase().includes(search.toLowerCase())
  //       );
  //     })
  //   );
  // }, [ongoing, search]);

  useEffect(() => {
    setData(
      cylinder?.filter((id) => {
        return Object.values(id).some((name) =>
          String(name).toLowerCase().includes(search.toLowerCase())
        );
      })
    );
  }, [cylinder, search]);

  useEffect(() => {
    setFilterData(data?.filter((id) => filter === id.status));
  }, [data, filter]);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const size = 5;
  const pagesVisited = pageNumber * size;
  const pageCount = Math.ceil(data?.length / size);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  return (
    <div>
      <div className="d-flex justify-content-between m-3">
        <div></div>
        <Search placeholder="Find any order here" onChange={handleChange} />
      </div>
      {/* {completedOrders.map((item) => (
        <Completed {...item} />
      ))} */}
      {loading && (
        <div className="d-flex justify-content-center align-items-center">
          <LinearLoader />
        </div>
      )}
      {data?.length > 0 ? (
        <>
          {
            // search
            // ? data?.map((item, index) => <Completed {...item} key={index} />)
            data
              ?.sort((a, b) => (a.tym > b.tym ? -1 : 1))
              ?.slice(pagesVisited, pagesVisited + size)
              ?.map((item, index) => (
                <Hospital {...item} key={index} />
              ))
          }
        </>
      ) : (
        <div className="d-flex justify-content-center align-items-center">
          <CircularLoader />
        </div>
      )}
      {data?.length > size && (
        <Pagination pageCount={pageCount} onPageChange={changePage} />
      )}
    </div>
  );
};

export default CylinderHospital;